/* ==========================================================================
   SearcherBusHotel > accommodation
   ========================================================================== */

/* Modules */
const InputClient = require('@bluekiri/alexandria-contrib-components/components/input/client/js');
const UiPanelaccommodationClient = require('../../../ui-panel-accommodation-packages/client/js');
const config = require('./config');

/* Init */
function initAccommodation(selector, instance) {
    /* Instance reference with trigger and panel */
    const result = {};

    const accommodationTrigger = getAccommodationType(instance.searcherType);
    const accommodationPanel = getAccommodationPanel(instance.searcherType);

    /* Input */
    result.trigger = InputClient(`${selector} ${accommodationTrigger.selector}`);
    result.trigger.setActive();

    /* Panel */
    result.panelAccommodation = UiPanelaccommodationClient(accommodationPanel.selector, {
        type: accommodationPanel.type,
        uiPanel: {
            type: accommodationPanel.type,
            selector: accommodationPanel.selector
        },
        actionAddRoom: {
            type: 'addRoom',
            selector: `${accommodationPanel.selector} [data-type="addRoom"]`
        },
        panel: {
            hasClose: accommodationPanel.hasClose,
            triggers: [instance.element.querySelector(`[data-type="${accommodationTrigger.type}"]`)],
            triggerInput: result.trigger
        }
    });

    /* Return the instance reference */
    return result;
}

function getAccommodationType(searcherType) {
    switch (searcherType) {
        case 'BusHotel':
            return config().accommodationTrigger;
        case 'Playas':
            return config().accommodationPlayasTrigger;
        case 'BusHotelModel':
            return config().accommodationModelTrigger;
        default:
            return config().accommodationTrigger;
    }
}

function getAccommodationPanel(searcherType) {
    switch (searcherType) {
        case 'BusHotel':
            return config().accommodationPanel;
        case 'Playas':
            return config().accommodationPlayasPanel;
        case 'BusHotelModel':
            return config().accommodationModelPanel;
        default:
            return config().accommodationPanel;
    }
}

module.exports = {
    initAccommodation
};
